import { Badge } from '@vrplatform/components';
import type { ThemeColor } from '@vrplatform/theme';
import { type Maybe, toTitleCase } from '@vrplatform/utils';
import type { syncStatus_enum } from '@vrplatform/graphql';

export const AutomationHistoryStatusBadge = ({
  status,
}: {
  status: Maybe<string>;
}) => {
  if (!status) return null;

  const badgeColors: Record<syncStatus_enum | (string & {}), ThemeColor> = {
    failed: 'red',
    started: 'yellow',
    completed: 'green',
    queued: 'yellow',
    canceled: 'gray',
  };

  return (
    <Badge color={badgeColors[status] || 'gray'} size="lg">
      {toTitleCase(status)}
    </Badge>
  );
};
